import { StyleSheet } from 'aphrodite'

import item from './item'
import list from './list'
import status from './status'

export default {
  list: StyleSheet.create(list),
  item: StyleSheet.create(item),
  status: StyleSheet.create(status)
}



// WEBPACK FOOTER //
// ./src/components/Community/partials/RevenueTable/style/ColorBlind/index.js